"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationsPage = void 0;
const NavigationContext_1 = require("@juvare/common-web-ui/NavigationContext");
const PageHeader_1 = require("@juvare/common-web-ui/PageHeader");
const SectionWithLinks_1 = require("@juvare/common-web-ui/SectionWithLinks");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const react_router_dom_1 = require("react-router-dom");
const ConfigurationsPage = ({ pages }) => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (react_1.default.createElement(react_router_1.Routes, null,
        react_1.default.createElement(react_router_1.Route, { index: true, element: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(PageHeader_1.PageHeaderWithImage, { gradient: 'blue-base', title: t('classifiers.configurationsPage') }),
                react_1.default.createElement(ClassifierMenu, { pages: pages })) }),
        pages.map(({ path, component: Component }) => (react_1.default.createElement(react_router_1.Route, { key: path, path: path, element: react_1.default.createElement(Component, null) },
            react_1.default.createElement(react_router_1.Route, { path: '*', element: react_1.default.createElement(Component, null) }))))));
};
exports.ConfigurationsPage = ConfigurationsPage;
const ClassifierMenu = ({ pages }) => {
    const navigationContext = react_1.default.useContext(NavigationContext_1.NavigationContext);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const uniqueGroups = Array.from(new Set(pages.map((page) => page.groupLabel))).sort();
    const sortedGroups = uniqueGroups.reduce((acc, group) => {
        const sortedLinks = pages
            .filter((page) => page.groupLabel === group)
            .map((page) => {
            return {
                href: page.path,
                label: page.label,
                onClick: () => {
                    navigationContext.navigate(() => navigate(page.path));
                },
            };
        })
            .sort((a, b) => (a.label > b.label ? 1 : -1));
        return [...acc, { title: group, links: sortedLinks }];
    }, []);
    return (react_1.default.createElement(material_1.Box, { p: 4 }, sortedGroups.map((group) => (react_1.default.createElement(SectionWithLinks_1.SectionWithLinks, { title: group.title, links: group.links })))));
};
